export type LibraryItem = {
  key: string;
  title: string;
  description: string;
  category: 'blueprint' | 'n8n' | 'ebook' | 'prompt';
  sector: string | null;
  fileType: 'pdf' | 'json' | 'md' | 'txt' | 'zip';
  sizeBytes: number;
  uploadedAt: string;
  thumbnailKey: string | null;
  thumbnailUrl: string | null;
  attachments: { key: string; fileType: 'pdf' | 'json' | 'md' | 'txt' | 'zip' }[];
};

export type DownloadRequest = {
  name: string;
  email: string;
  phone: string;
  projectType: string;
  blueprintKey: string;
  attachmentKeys: string[];
  turnstileToken: string;
};

export type DownloadResponse = {
  downloadUrl: string;
  filename: string;
  attachments: { downloadUrl: string; filename: string }[];
};

export async function fetchLibrary(): Promise<LibraryItem[]> {
  const res = await fetch('/api/library');
  // 503 = library storage not yet configured → render empty state, not error.
  if (res.status === 503) {
    const data = (await res
      .json()
      .catch(() => ({ items: [] as LibraryItem[] }))) as {
      items?: LibraryItem[];
    };
    return data.items ?? [];
  }
  if (!res.ok) throw new Error('Failed to load library');
  const data = (await res.json()) as { items: LibraryItem[] };
  return data.items;
}

export async function requestDownload(
  body: DownloadRequest
): Promise<DownloadResponse> {
  const res = await fetch('/api/download', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(text || `Request failed (${res.status})`);
  }
  return (await res.json()) as DownloadResponse;
}
